import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { Sparkles, Brain, Battery, Unlock } from 'lucide-react';
export function RevelationSection() {
  const benefits = [{
    icon: <Unlock data-id="element-165" />,
    text: 'Soltar la grasa acumulada sin esfuerzo'
  }, {
    icon: <Battery data-id="element-166" />,
    text: 'Estabilizar el ánimo y la energía'
  }, {
    icon: <Brain data-id="element-167" />,
    text: 'Devolverte la claridad mental de los 30'
  }];
  return <section className="py-24 px-4 bg-sage text-white relative overflow-hidden" data-id="element-168">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-169">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-white rounded-full blur-3xl" data-id="element-170"></div>
        <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-gold rounded-full blur-3xl" data-id="element-171"></div>
      </div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-172">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-173">
          <div className="inline-flex items-center gap-2 bg-white/20 px-4 py-2 rounded-full text-sm font-bold tracking-wider mb-8 uppercase" data-id="element-174">
            <Sparkles className="w-4 h-4" data-id="element-175" />
            La Solución Definitiva
          </div>

          <h2 className="font-heading text-3xl md:text-5xl font-bold mb-8 leading-tight" data-id="element-176">
            La solución no es comer menos información,
            <br data-id="element-177" />
            <span className="text-gold-light italic" data-id="element-178">
              es comer mejor información.
            </span>
          </h2>

          <p className="text-lg md:text-xl text-white/90 mb-12 leading-relaxed max-w-3xl mx-auto" data-id="element-179">
            Existe un "Código" biológico que, cuando se activa, le permite a tu
            cuerpo funcionar como una orquesta perfectamente afinada. No es
            magia, es{' '}
            <strong className="text-gold-light font-bold" data-id="element-180">
              Sensibilidad Insulínica y Control de Cortisol
            </strong>
            .
          </p>

          <div className="grid md:grid-cols-3 gap-6 mb-16" data-id="element-181">
            {benefits.map((benefit, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: i * 0.1
          }} className="bg-white/10 backdrop-blur-sm border border-white/20 p-6 rounded-2xl flex flex-col items-center text-center gap-4" data-id="element-182">
                <div className="w-12 h-12 bg-gold/20 rounded-full flex items-center justify-center text-gold-light" data-id="element-183">
                  {benefit.icon}
                </div>
                <p className="font-medium text-lg" data-id="element-184">{benefit.text}</p>
              </motion.div>)}
          </div>

          <div className="bg-white/5 border border-white/10 p-8 rounded-2xl mb-12" data-id="element-185">
            <p className="text-xl md:text-2xl font-heading italic" data-id="element-186">
              "Cuando aprendes a alimentar tu orquesta hormonal en el orden
              correcto, el peso cae por sí solo."
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}